import {SETTINGS_PAGE_SLUG, HOME_PAGE_SLUG} from '../constants';

import {trimSlashes} from './trim-slashes';

const ROOT_PATH = '/';

function parseHandler(rawPath: string) {
    const indexOfHandler = rawPath.indexOf('/.');

    if (indexOfHandler > -1) {
        return {
            path: rawPath.substring(0, indexOfHandler + 1),
            handler: rawPath.substring(indexOfHandler + 1),
        };
    }

    return {
        path: rawPath,
        handler: '',
    };
}

function isRoot(path: string) {
    return path === ROOT_PATH;
}

function isHomePage(path: string) {
    return isRoot(path) || trimSlashes(path) === HOME_PAGE_SLUG;
}

function parsePath(rawPath: string) {
    const {path, handler} = parseHandler(rawPath);
    const isRootPath = isRoot(path);
    const isSettings = trimSlashes(path) === SETTINGS_PAGE_SLUG;

    return {
        normalizedPath: isRootPath || isSettings ? HOME_PAGE_SLUG : trimSlashes(path),
        pathname: path,
        handler,
        isRoot: isRootPath,
        isSettings,
        // для старых мидлварь
        path: isRootPath || isSettings ? `/${HOME_PAGE_SLUG}/` : path,
    };
}

export {parsePath, isRoot, isHomePage};
